import React, {useState} from 'react';
import {NewsProps} from "../types/news";
import NewsItem from "../components/NewsItem";
import {useTranslation} from "../hooks/useTranslation";

function NewsList({itemsPerPage, items} : NewsProps) {
    const [visibleItemsCount, setVisibleItemsCount] = useState(itemsPerPage);
    const [buttonIsVisible, setButtonIsVisible] = useState(itemsPerPage < items.length);

    const translate =useTranslation();

    const loadMoreClickHandler = () => {
        setVisibleItemsCount(visibleItemsCount + itemsPerPage);
        setButtonIsVisible(visibleItemsCount + itemsPerPage < items.length);
    };

    const newsList = items.map((item, index) => {
        const isVisible = index + 1 <= visibleItemsCount;

        return (
            <NewsItem index={index} isVisible={isVisible} item={item} />
        )
    });

    return (
        <div className="newsList inner-1150">
            {items.length === 0 &&
                <div className="newsList__no--results">
                    {translate('news_no_news_found')}
                </div>
            }
            <div className="newsItem__list">
                {newsList}
            </div>
            {buttonIsVisible &&
                <div className="newsList__button">
                    <div className="btn" onClick={loadMoreClickHandler}>
                        {translate('news_load_more')}
                    </div>
                </div>
            }
        </div>
    );
}

export default NewsList;
